/**************************************************
 * 食品のカテゴリーから選ぶ・地域から選ぶ・価格から選ぶ
 **************************************************/
const sliderConfigs = [
  { target: ".footer_cate_outer", prefix: ".cate" }
];

// Swiperのインスタンスを保持する配列
let swiperInstances = [];

const handleSwiper = () => {
  const isPC = window.matchMedia('(min-width: 768px)').matches;

  if (isPC) {
    // 【PC時】インスタンスがなければ初期化
    if (swiperInstances.length === 0) {
      sliderConfigs.forEach((config, index) => {
        const instance = new Swiper(`${config.target}.swiper-container`, {
          // スライドが足りない時に矢印などを自動で隠す
          watchOverflow: true,
          navigation: {
            nextEl: `${config.prefix} .swiper-button-next`,
            prevEl: `${config.prefix} .swiper-button-prev`,
          },
          pagination: {
            el: `${config.prefix} .swiper-pagination`,
            clickable: true,
          },
          slidesPerView: 7, // PC時の表示数
          spaceBetween: 20, // 必要に応じて余白を設定
        });
        swiperInstances.push(instance);
      });
    }
  } else {
    // 【スマホ時】インスタンスがあれば破棄
    if (swiperInstances.length > 0) {
      swiperInstances.forEach(instance => {
        instance.destroy(true, true); // スタイルも完全にクリア
      });
      swiperInstances = []; // 配列を空にする
    }
  }
};

// 初回実行
handleSwiper();

// 画面リサイズ時に実行（負荷軽減のためリスナーを使用）
window.addEventListener('resize', handleSwiper);

/**************************************************
 * 地域から選ぶ・価格から選ぶ（PC表示 768px以上のみ有効）
 **************************************************/
// 変数名を「1」付きにして重複を回避
const sliderConfigs1 = [
  { target: ".footer_area_outer", prefix: ".area" },
  { target: ".footer_price_outer", prefix: ".price" }
];

// インスタンス保持用の配列も個別に用意
let swiperInstances1 = [];

const handleSwiper1 = () => {
  const isPC = window.matchMedia('(min-width: 768px)').matches;

  if (isPC) {
    // PC：インスタンスがなければ初期化
    if (swiperInstances1.length === 0) {
      sliderConfigs1.forEach(config => {
        const instance = new Swiper(`${config.target}.swiper-container`, {
          // スライドが足りない時に矢印などを自動で隠す
          watchOverflow: true,
          navigation: {
            nextEl: `${config.prefix} .swiper-button-next`,
            prevEl: `${config.prefix} .swiper-button-prev`,
          },
          pagination: {
            el: `${config.prefix} .swiper-pagination`,
            clickable: true,
          },
          slidesPerView: 6, // 元のコードのPC用枚数
          spaceBetween: 15, // 適宜調整してください
        });
        swiperInstances1.push(instance);
      });
    }
  } else {
    // スマホ：インスタンスがあれば破棄
    if (swiperInstances1.length > 0) {
      swiperInstances1.forEach(instance => {
        instance.destroy(true, true);
      });
      swiperInstances1 = []; // 配列をリセット
    }
  }
};

// 初回実行とリサイズ監視
handleSwiper1();
window.addEventListener('resize', handleSwiper1);

/**************************************************
 * フッターの返礼品検索タブ
 **************************************************/
document.querySelectorAll('.footer-search').forEach((search) => {
  const tabs = Array.from(search.querySelectorAll('[data-footer-search-tab]'));
  const panels = Array.from(search.querySelectorAll('[data-footer-search-panel]'));

  const activateTab = (tab) => {
    const target = tab.dataset.footerSearchTab;

    tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', String(isActive));
      item.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.footerSearchPanel === target;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    // 非表示中に初期化されたSwiperの幅を再計算する。
    window.requestAnimationFrame(() => {
      swiperInstances1.forEach((instance) => instance.update());
    });
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(tab));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      let nextIndex = index;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;

      activateTab(tabs[nextIndex]);
      tabs[nextIndex].focus();
    });
  });
});

/**************************************************
 * 担当者のおすすめ商品一覧
 **************************************************/
const swiper_osusume = new Swiper(".top_osusume_outer", {
  // スライドが足りない時に矢印などを自動で隠す
  watchOverflow: true,
  slidesPerView: 1,
  spaceBetween: 0,
  slidesPerView: 1.3,
  loop: true,
  pagination: {
    el: ".top_osusume_outer .swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 4,
      navigation: {
        nextEl: ".top_osusume_outer ~ .swiper-button-ranking-next",
        prevEl: ".top_osusume_outer ~ .swiper-button-ranking-prev",
      },
    },
  },
});

/**************************************************
 * お客様のお声
 **************************************************/
/**************************************************
 * お客様のお声（複数対応版）
 **************************************************/
// コンテナとなる要素をすべて取得してループ
const voiceContainers = document.querySelectorAll(".footer_contents_container.voice");

voiceContainers.forEach((container) => {
  // コンテナ内の特定のクラスを持つ要素を探す
  const slider = container.querySelector(".footer_voice_outer");
  const paginationEl = container.querySelector(".voice .swiper-pagination");
  const nextEl = container.querySelector(".voice .swiper-button-next");
  const prevEl = container.querySelector(".voice .swiper-button-prev");

  new Swiper(slider, {
    watchOverflow: true,
    pagination: {
      el: paginationEl, // このコンテナ内のページネーションを指定
      type: "bullets",
      clickable: true,
    },
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 3,
        navigation: {
          nextEl: nextEl, // このコンテナ内の矢印を指定
          prevEl: prevEl, // このコンテナ内の矢印を指定
        },
      },
    }
  });
});

// 商品ページ・地域ページ・TOPなど、ページ内のレビューカルーセルを個別に初期化
const productReviewSliders = document.querySelectorAll(".product_review_outer.swiper-container");

productReviewSliders.forEach((slider) => {
  const reviewContainer = slider.closest(".review");
  if (!reviewContainer) return;

  const nextEl = reviewContainer.querySelector(".swiper-button-next");
  const prevEl = reviewContainer.querySelector(".swiper-button-prev");
  const paginationEl = reviewContainer.querySelector(".swiper-pagination");

  new Swiper(slider, {
    // スライドが足りない時に矢印などを自動で隠す
    watchOverflow: true,
    // 前後の矢印
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    // ページネーション
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    // スライドの表示枚数
    slidesPerView: 1,
    breakpoints: {
      // 768px以上の場合
      768: {
        slidesPerView: 2,
      },
    }
  });
});

/**************************************************
 * お役立ちコンテンツ（複数対応版）
 **************************************************/
// 共通の親要素、あるいはSwiper本体のクラスを指定
const articleSliders = document.querySelectorAll(".footer_article_outer");

articleSliders.forEach((slider) => {
  // 矢印・ページネーションの位置がカルーセルごとに異なる（スライダー兄弟 or 一段上）ため、
  // 共通の祖先 .footer_contetns_links_div を基点に探す（無ければ直近の親にフォールバック）
  const parent = slider.closest(".footer_contetns_links_div") || slider.parentElement;
  const nextEl = parent.querySelector(".swiper-button-next");
  const prevEl = parent.querySelector(".swiper-button-prev");
  const paginationEl = parent.querySelector(".swiper-pagination");

  new Swiper(slider, {
    watchOverflow: true,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    pagination: {
      el: paginationEl,
      clickable: true,
      dynamicBullets: false,
    },
    slidesPerView: 2,
    breakpoints: {
      768: {
        slidesPerView: 5,
        // PCもSPも通常のドット表示に統一。
        pagination: {
          el: paginationEl,
          clickable: true,
          dynamicBullets: false,
        },
      },
    }
  });
});

/**************************************************
 * TOP
 **************************************************/
// スライダーの設定を配列で定義
const sliderConfigsC = [
  { target: ".top_campaign", prefix: ".block_index_campaign" }
];

sliderConfigsC.forEach(config => {
  new Swiper(`${config.target}.swiper-container`, {
    // スライドが足りない時に矢印などを自動で隠す
    watchOverflow: true,
    spaceBetween: 10,
    slidesPerView: 1.3,
    loop: true,
    centeredSlides: true,
    pagination: {
      el: `${config.prefix} .swiper-pagination`,
      clickable: true,
    },
    breakpoints: {
      // 768px以上の場合
      768: {
        spaceBetween: 20,
        slidesPerView: 3,
        centeredSlides: false,
        navigation: {
          nextEl: `${config.prefix} .swiper-button-next`,
          prevEl: `${config.prefix} .swiper-button-prev`,
        },
      },
    },
  });
});

/**************************************************
 * 「ふるさと うまいもの 大全集」について
 **************************************************/
// スライダーの設定を配列で定義
const sliderConfigsTSU = [
  { target: ".toha_outer", prefix: ".block_index_kodawari" }
];

sliderConfigsTSU.forEach(config => {
  new Swiper(`${config.target}.swiper-container`, {
    // スライドが足りない時に矢印などを自動で隠す
    watchOverflow: true,
    slidesPerView: 1,
    slidesPerView: 1.2,
    loop: true,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination", //ページネーションの要素
      type: "bullets", //ページネーションの種類
      clickable: true, //クリックに反応させる
    },
    breakpoints: {
      // 768px以上の場合
      768: {
        //slidesPerView: 1.5,
        slidesPerView: 2.1,
        navigation: {
          nextEl: `${config.prefix} .btn_next`,
          prevEl: `${config.prefix} .btn_prev`,
        },
      },
    },
  });
});

/**************************************************
 * 記事ページ
 **************************************************/
// スライダーの設定を配列で定義
const sliderConfigsPL = [
  { target: ".pagelink_swiper", prefix: ".pagelink_outer" }
];

sliderConfigsPL.forEach(config => {
  new Swiper(`${config.target}.swiper-container`, {
    // スライドが足りない時に矢印などを自動で隠す
    watchOverflow: true,
    slidesPerView: 2,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: `${config.prefix} .swiper-pagination`,
      clickable: true,
    },
    breakpoints: {
      // 768px以上の場合
      768: {
        spaceBetween: 20,
        //slidesPerView: 1.5,
        slidesPerView: 3,
        navigation: {
          nextEl: `${config.prefix} .swiper-button-next`,
          prevEl: `${config.prefix} .swiper-button-prev`,
        },
      },
    },
  });
});

// ランキング
var galleryTop_t3 = new Swiper(".top_ranking_outer", {
  // スライドが足りない時に矢印などを自動で隠す
  watchOverflow: true,
  slidesPerView: 1,
  spaceBetween: 0,
  slidesPerView: 1.3,
  loop: true,
  pagination: {
    el: ".top_ranking_outer .swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 4,
      navigation: {
        nextEl: ".top_ranking_outer ~ .swiper-button-ranking-next",
        prevEl: ".top_ranking_outer ~ .swiper-button-ranking-prev",
      },
    },
  },
});

/**************************************************
 * ポップアップ
 **************************************************/
// 開く処理
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.modal-toggle');
  if (btn) {
    const targetId = btn.dataset.target;
    // ★ Swiper外に移動したのでdocument全体から検索
    const modal = document.getElementById(targetId);

    if (modal) {
      modal.showModal();
    }
  }
});

// 閉じる処理（閉じるボタン・背景クリック共通）
document.addEventListener('click', (e) => {
  const closeBtn = e.target.closest('.close-btn');
  // ★ dialog要素自身のクリックで背景クリックを検知
  const overlay = e.target.tagName === 'DIALOG' ? e.target : null;

  const targetToClose = closeBtn ? closeBtn.closest('dialog') : overlay;

  if (targetToClose) {
    targetToClose.close();
  }
});
